const checkTokenExpiration = tokenExpireTime => (tokenExpireTime < Date.now() / 1000)

export default checkTokenExpiration
